<template>
  <div
    class="rex-service-sel"
    :tabindex="tabindex"
    @blur="open = false"
    :style="{ width: width, height: height }"
    :class="{ pagination: pagination, active: open, disabled: disabled }"
  >
    <div @click="!disabled && (open = !open)">
      <slot name="selected-field" :selected="selected">
        <div
          :class="[
            disabled ? 'disabled' : 'selected',
            'ellipsis',
            open && 'open',
          ]"
        >
          <div class="selected-text-container selected-pre-icon">
            <BaseIcon
              v-if="isIconReq"
              :name="iconDetails.name"
              :width="iconDetails.width"
              :height="iconDetails.height"
            />
            <div
              class="selected-text ellipsis"
              :class="{ selectedTextWithIcon: isIconReq }"
              :style="{ color: selected.color }"
              v-tooltip:right.ellipsis="selected.name || selected.label"
            >
              {{ selected.name }}
            </div>
          </div>
        </div>
      </slot>
    </div>

    <div class="items" :class="{ selectHide: !open, invert: invert }">
      <slot name="before-options"></slot>
      <div
        v-for="(option, i) of options"
        :key="i"
        @click="
          selected = option;
          open = false;
          $emit('input', option.value, option);
          defaultValueHandler && defaultValueHandler();
        "
        class="item-text ellipsis"
        :style="option.color && getLabelColor(option.color, i)"
        v-tooltip:bottom.ellipsis="option ? option.value : ''"
        @mouseover="handleHover(i)"
        @mouseout="handleHover(-1)"
      >
        {{ option.name }}
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Select field enables to select option from the provided list of options
 */
export default {
  props: {
    /**
     *
     *List of available options to select
     *
     */
    options: {
      type: Array,
      required: true,
    },
    /**
     *
     *Default option to be selected
     *
     */
    default: {
      type: String,
      required: false,
      default: null,
    },
    /**
     *
     *Width of select field
     *
     */
    width: { type: String, default: '4.8em' },
    /**
     *
     *Height of select field
     *
     */
    height: { type: String, default: '2.6em' },
    /**
     *
     *Index number of tab to select the field (enables support for focus & blur event for non form input elements (like: div))
     *
     */
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    /**
     *
     *Function that handles the default value
     *
     */
    defaultValueHandler: {
      type: Function,
      required: false,
    },
    /**
     *
     *Invoke clear
     *
     */
    invokeClear: {
      type: Boolean,
      required: false,
    },
    /**
     *
     *Invert the options container
     *
     */
    invert: {
      type: Boolean,
      default: false,
    },
    /**
     *
     *Is select required for pagination
     *
     */
    pagination: {
      type: Boolean,
      default: false,
    },
    /**
     *
     *Boolean enabled to display icon in the select field
     *
     */
    isIconReq: {
      type: Boolean,
      default: false,
    },
    /**
     *
     *Details of the icon field
     *
     */
    iconDetails: {
      type: Object,
      default: () => ({}),
    },
    /**
     *
     *Boolean to disable the select options
     *
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.default
        ? this.setDefault(this.default)
        : this.options.length > 0
          ? this.options[0]
          : { label: '' },
      open: false,
      hoveredIndex: -1,
    };
  },
  mounted() {
    // this.$emit('input', this.selected.value);
  },
  methods: {
    setDefault(desiredOption = null) {
      if (!desiredOption) {
        this.selected = this.options[0];
        this.$emit('input', this.selected.value);
      } else {
        for (let option of this.options) {
          if (option.value == desiredOption) {
            return option;
          }
        }
        return { label: '' };
      }
    },
    getLabelColor(labelColor, index) {
      return {
        color: this.hoveredIndex === index ? '#000000' : labelColor,
      };
    },
    handleHover(value) {
      this.hoveredIndex = value;
    },
  },
  watch: {
    options() {
      this.selected = this.default
        ? this.setDefault(this.default)
        : this.options.length > 0
          ? this.options[0]
          : { label: '' };
    },
    default(newVal, oldVal) {
      if (!newVal) return;
      for (let option of this.options) {
        if (option.value === newVal) {
          this.selected = option;
          this.$emit('input', this.selected.value);
          break;
        }
      }
    },
    invokeClear(newVal, oldVal) {
      if (!newVal) return;
      this.setDefault();
    },
  },
};
</script>

<style lang="scss" scoped>
.rex-service-sel {
  position: relative;
  width: 37.0625em;
  text-align: left;
  outline: none;
  height: 2.5em;
  line-height: 1.375em;
  border-radius: 7px;
  border: 0.5px solid $border-primary;
  background-color: $bg-primary;

  // margin-top: 1rem;
  color: $font-primary;
}
.selected-text {
  margin-top: 0.45rem;
  margin-bottom: 0.5313em;
  font-size: 1.1em;
  margin-left: 0.85em;
}

.selected {
  background-color: transparent;
  color: $font-primary;
  cursor: pointer;
  user-select: none;
  height: 2.5em;
  width: 80%;
}
.active {
  @include active-state;
}
.selected.open {
  border-radius: 0.375rem 0.375rem 0rem 0rem;
}
.selected:after {
  position: absolute;
  content: '';
  top: 1.1em;
  right: 0.8em;
  width: 0;
  height: 0;
  border: 0.3125rem solid transparent;
  border-color: $font-primary transparent transparent transparent;
}
.items {
  color: $font-primary;
  border-radius: 0.4375em;
  //   overflow: hidden;
  background-color: $bg-primary;

  border-right: 0.0625rem solid $border-primary;
  border-left: 0.0625rem solid $border-primary;
  border-bottom: 0.0625rem solid $border-primary;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
  max-height: 12.5em;
  height: auto;
  @include active-state;
  overflow-y: scroll;
}
.pagination {
  // border: 0.5px solid $border-primary;
  display: flex;
  flex-direction: column;
}
.invert {
  bottom: 100%;
}

.item-text {
  padding: 0.5em;
  padding-left: 0.875em;
  font-size: 1em;
}
.item-text:hover {
  background-color: $color-brand-accent;
  color: $font-contrast;
}

.text-class {
  margin-top: 0.5em;
  margin-bottom: 0.9375em;
}
.rex-service-sel .items div:hover {
  cursor: pointer;
}

.selectHide {
  display: none;
}

.selected-text-container {
  display: flex;
  align-items: center;
  margin-right: -0.5rem;
}
.selectedTextWithIcon {
  margin-left: 0.625rem !important;
}
.disabled {
  background-color: transparent;
  color: $font-primary;
  height: 2.5em;
  opacity: 0.7;
}
.selected-pre-icon {
  margin-left: 0rem !important;
}
</style>
